import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      title: formatMessage(messages.title),
      description: formatMessage(messages.description),
    };
  }, [formatMessage]);

  return translations;
};

export default useTranslations;
